import { render, staticRenderFns } from "./LangChooser.vue?vue&type=template&id=8bd11254"
import script from "./LangChooser.vue?vue&type=script&lang=ts"
export * from "./LangChooser.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports